module.exports = __webpack_public_path__ + "static/media/section_3_A.b236d205.png";